"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Input = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _configs = require("./configs");
var _styledInput = require("./styled-input");
var _excluded = ["className", "dataTestId", "disabled", "helperText", "id", "isRequired", "label", "leading", "maskButton", "maxCharacterCount", "onChange", "onKeyUp", "state", "type", "componentId"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef,
  useRef = _react["default"].useRef,
  useState = _react["default"].useState;
var propTypes = {
  label: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  helperText: _propTypes["default"].string,
  id: _propTypes["default"].string,
  isRequired: _propTypes["default"].bool,
  leading: _propTypes["default"].string,
  maskButton: _propTypes["default"].bool,
  maxCharacterCount: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  state: _propTypes["default"].string,
  type: _propTypes["default"].string,
  componentId: _propTypes["default"].string
};
var defaultProps = {
  className: undefined,
  dataTestId: null,
  disabled: false,
  helperText: undefined,
  id: undefined,
  isRequired: false,
  leading: undefined,
  maskButton: false,
  maxCharacterCount: undefined,
  onChange: undefined,
  onKeyUp: undefined,
  state: undefined,
  type: 'text',
  componentId: (0, _fuseUtils.uuid)()
};
var Input = exports.Input = forwardRef(function (_ref, ref) {
  var className = _ref.className,
    dataTestId = _ref.dataTestId,
    disabled = _ref.disabled,
    helperText = _ref.helperText,
    id = _ref.id,
    isRequired = _ref.isRequired,
    label = _ref.label,
    leading = _ref.leading,
    maskButton = _ref.maskButton,
    maxCharacterCount = _ref.maxCharacterCount,
    onChange = _ref.onChange,
    onKeyUp = _ref.onKeyUp,
    state = _ref.state,
    type = _ref.type,
    componentId = _ref.componentId,
    rest = _objectWithoutProperties(_ref, _excluded);
  // Config values
  var componentName = _configs.config.componentName,
    icon = _configs.config.icon,
    leadingConfig = _configs.config.leading,
    maskIconButton = _configs.config.maskIconButton;
  var borderColor = _configs.styledInputConfig.borderColor;
  // Ids for input element, helper text, mask button and input icon states
  var inputId = "".concat(componentName, "-input-").concat(componentId);
  var helperTextId = helperText && "".concat(componentName, "-helper-text-").concat(componentId);
  var maskButtonId = maskButton && "".concat(componentName, "-mask-button-").concat(componentId);
  var inputIconId = state && (state === 'error' || state === 'success') && "".concat(componentName, "-input-icon-").concat(componentId);
  // Refs for input container and input element
  var inputContainerRef = useRef();
  var inputRef = useRef();
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    inputLength = _useState2[0],
    setInputLength = _useState2[1];
  // Verify leading based on config i.e. pound or euro
  var leadingChar = leadingConfig === null || leadingConfig === void 0 ? void 0 : leadingConfig[leading === null || leading === void 0 ? void 0 : leading.toLowerCase()];
  var leadingCharId = leadingChar && "".concat(componentName, "-leading-character-").concat(componentId);
  // Sanitising Max Character Count and set max value for type number
  // eslint-disable-next-line no-restricted-globals
  var sanitisedMaxCharCount = !isNaN(maxCharacterCount) && maxCharacterCount;
  var maxCharacterCountId = sanitisedMaxCharCount && "".concat(componentName, "-max-character-count-").concat(componentId);
  // Mask Icon Button Values
  var defaultMaskButtonState = {
    maskButtonSrLabel: maskIconButton === null || maskIconButton === void 0 ? void 0 : maskIconButton.showIconSrLabel(label),
    maskButtonClassName: maskIconButton === null || maskIconButton === void 0 ? void 0 : maskIconButton.showIconClassName,
    maskButtonIcon: maskIconButton === null || maskIconButton === void 0 ? void 0 : maskIconButton.showIcon
  };
  var _useState3 = useState(defaultMaskButtonState),
    _useState4 = _slicedToArray(_useState3, 2),
    maskButtonObj = _useState4[0],
    setMaskButtonObj = _useState4[1];
  var maskButtonColor = _configs.styledInputConfig === null || _configs.styledInputConfig === void 0 ? void 0 : _configs.styledInputConfig.maskIconButton.color;
  var maskButtonSize = _configs.styledInputConfig === null || _configs.styledInputConfig === void 0 ? void 0 : _configs.styledInputConfig.maskIconButton.size;
  // Handler to mask and unmask input value
  var handleMaskButtonClick = function handleMaskButtonClick() {
    var isPasswordType = (maskButtonObj === null || maskButtonObj === void 0 ? void 0 : maskButtonObj.maskButtonIcon) === (maskIconButton === null || maskIconButton === void 0 ? void 0 : maskIconButton.showIcon);
    if (isPasswordType) {
      inputRef.current.setAttribute('type', 'text');
      setMaskButtonObj({
        maskButtonSrLabel: maskIconButton === null || maskIconButton === void 0 ? void 0 : maskIconButton.hideIconSrLabel(label),
        maskButtonClassName: maskIconButton === null || maskIconButton === void 0 ? void 0 : maskIconButton.hideIconClassName,
        maskButtonIcon: maskIconButton === null || maskIconButton === void 0 ? void 0 : maskIconButton.hideIcon
      });
    } else {
      inputRef.current.setAttribute('type', 'password');
      setMaskButtonObj(defaultMaskButtonState);
    }
  };
  // Handler to programmtically remove focus outline only when input has focus and is tabbed
  var handleContainerBlur = function handleContainerBlur() {
    inputContainerRef.current.classList.remove("".concat(componentName, "__input-container--outline"));
  };
  // Handler to programmtically set focus outline only when input has focus and is tabbed
  var handleContainerKeyUp = function handleContainerKeyUp(_ref2) {
    var keyCode = _ref2.keyCode;
    var tabKey = 9;
    if (keyCode === tabKey && document.activeElement === inputRef.current) inputContainerRef.current.classList.add("".concat(componentName, "__input-container--outline"));
    if (document.activeElement !== inputRef.current) inputContainerRef.current.classList.remove("".concat(componentName, "__input-container--outline"));
  };
  // Handler to limit characters for input type number when max character is set
  var handleInputOnChange = function handleInputOnChange(e) {
    /**
     * Force input to limit characters only when maxCharacterCount is set and input type === number
     * This is due to input maxLength attribute doesn't work on input type="number"
     */
    if (sanitisedMaxCharCount && type === 'number') e.target.value = e.target.value.slice(0, sanitisedMaxCharCount);
    // If onChange prop is set, then run this to avoid overriding the above function
    if (onChange) onChange(e);
  };
  // Handler to render input character count
  var handleInputOnKeyUp = function handleInputOnKeyUp(e) {
    // Render input length only when maxCharacterCount is set
    if (sanitisedMaxCharCount) setInputLength(e.target.value.length);
    // If onKeyUp prop is set, then run this to avoid overriding the above function
    if (onKeyUp) onKeyUp(e);
  };
  return /*#__PURE__*/_react["default"].createElement(_styledInput.StyledWrapper, {
    className: "".concat(className, " ").concat(disabled ? 'fuse-input--disabled' : ''),
    "data-testid": dataTestId,
    id: id,
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement(_styledInput.StyledLabel, {
    htmlFor: inputId
  }, label, isRequired && ' *'), /*#__PURE__*/_react["default"].createElement(_styledInput.StyledInputContainer, {
    ref: inputContainerRef,
    state: state,
    onBlur: handleContainerBlur,
    onKeyUp: handleContainerKeyUp
  }, leadingChar && /*#__PURE__*/_react["default"].createElement(_styledInput.StyledLeadingCharacter, {
    id: leadingCharId
  }, /*#__PURE__*/_react["default"].createElement(_fuseUtils.StyledScreenReaderSpan, null, "Currency"), /*#__PURE__*/_react["default"].createElement("abbr", {
    title: leading === null || leading === void 0 ? void 0 : leading.toLowerCase()
  }, leadingChar)), /*#__PURE__*/_react["default"].createElement(_styledInput.StyledInput, _extends({
    "aria-describedby": leadingCharId || inputIconId || helperTextId || maxCharacterCountId ? "".concat(leadingCharId || '', " ").concat(inputIconId || '', " ").concat(helperTextId || '', " ").concat(maxCharacterCountId || '') : undefined,
    "aria-disabled": disabled,
    "aria-invalid": state === 'error' ? true : undefined,
    disabled: disabled,
    id: inputId,
    maxLength: sanitisedMaxCharCount || undefined,
    onChange: handleInputOnChange,
    onKeyUp: handleInputOnKeyUp,
    ref: inputRef,
    required: isRequired,
    type: maskButton ? 'password' : type
  }, rest)), maskButton && /*#__PURE__*/_react["default"].createElement(_styledInput.StyledMaskButton, {
    "aria-disabled": disabled,
    "aria-live": "polite",
    callback: handleMaskButtonClick,
    className: maskButtonObj === null || maskButtonObj === void 0 ? void 0 : maskButtonObj.maskButtonClassName,
    color: maskButtonColor,
    disabled: disabled,
    id: maskButtonId,
    icon: maskButtonObj === null || maskButtonObj === void 0 ? void 0 : maskButtonObj.maskButtonIcon,
    size: maskButtonSize,
    srLabel: maskButtonObj === null || maskButtonObj === void 0 ? void 0 : maskButtonObj.maskButtonSrLabel
  }), (icon === null || icon === void 0 ? void 0 : icon[state]) && /*#__PURE__*/_react["default"].createElement(_styledInput.StyledInputIcon, {
    color: borderColor === null || borderColor === void 0 ? void 0 : borderColor[state],
    icon: icon === null || icon === void 0 ? void 0 : icon[state].state,
    id: inputIconId,
    srLabel: icon === null || icon === void 0 ? void 0 : icon[state].label,
    responsiveSize: icon.size
  })), ((helperText === null || helperText === void 0 ? void 0 : helperText.length) > 0 || sanitisedMaxCharCount) && /*#__PURE__*/_react["default"].createElement(_styledInput.StyledDescriptionContainer, {
    isHelperText: (helperText === null || helperText === void 0 ? void 0 : helperText.length) > 0
  }, (helperText === null || helperText === void 0 ? void 0 : helperText.length) > 0 && /*#__PURE__*/_react["default"].createElement(_styledInput.StyledHelperText, {
    id: helperTextId,
    type: "paragraph",
    size: "m1",
    state: state,
    tag: "p"
  }, helperText), Number(sanitisedMaxCharCount) >= 1 && /*#__PURE__*/_react["default"].createElement(_styledInput.StyledCharacterCounter, {
    id: maxCharacterCountId,
    type: "paragraph",
    size: "m1",
    state: state,
    tag: "p"
  }, inputLength, "/", sanitisedMaxCharCount, /*#__PURE__*/_react["default"].createElement(_fuseUtils.StyledScreenReaderSpan, null, " characters"))));
});
Input.propTypes = propTypes;
Input.defaultProps = defaultProps;
var _default = exports["default"] = Input;